module.exports = __webpack_public_path__ + "217ca795c415113a6f831dab8634f872.svg";